import './style.scss'
import './components'

export { default } from './player'



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/aliplayer/index.js